import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

// Draeger brand colors
const draegerPrimary = '#002766'; // Dark navy blue
const draegerSecondary = '#1a4a8f'; // Lighter navy for accents
const draegerAccent = '#0052cc'; // Brighter blue for highlights

export const draegerTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: draegerPrimary,
      },
      secondary: {
        main: draegerSecondary,
      },
      navigation: {
        background: draegerPrimary,
        indicator: '#ffffff',
        color: '#ffffff',
        selectedColor: '#ffffff',
        navItem: {
          hoverBackground: draegerSecondary,
        },
      },
      background: {
        default: '#f8f9fa',
        paper: '#ffffff',
      },
      banner: {
        info: draegerAccent,
        error: '#d32f2f',
        text: '#ffffff',
        link: '#ffffff',
      },
    },
  }),
  defaultPageTheme: 'home',
  fontFamily:
    'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  pageTheme: {
    home: genPageTheme({
      colors: [draegerPrimary, draegerSecondary],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: [draegerPrimary, draegerSecondary],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: [draegerSecondary, draegerAccent],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: [draegerPrimary, draegerSecondary],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: [draegerPrimary, draegerSecondary],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: [draegerPrimary, draegerSecondary],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: [draegerPrimary, draegerSecondary],
      shape: shapes.wave,
    }),
    app: genPageTheme({
      colors: [draegerPrimary, draegerSecondary],
      shape: shapes.wave,
    }),
    apis: genPageTheme({
      colors: [draegerSecondary, draegerAccent],
      shape: shapes.wave,
    }),
  },
});
